module.exports = __webpack_public_path__ + "fonts/30b0d5e.eot";